export const tr = {
    campaignCreated: 'Kampanya oluşturuldu',
    hasModeration: 'Kampanyayı moderasyona gönderin',
    hasMoney: 'Ortak hesapta bakiye olduğundan emin olun',
    later: 'Daha sonra',
    sendToModeration: 'Moderasyona gönder',
    showConditions: 'Bu kampanya çerçevesinde reklam gösterimlerini başlatmak için:'
};
